/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-20 15:23:09
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-26 14:06:21
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/Filter/PreConfig/SalesChannel/index.tsx
 */

import Cascader from '../../Cascader';
import { EnumFilterType } from '../../index';

export function salesChannelFilter({ options, dropdownName, key }) {
  const keyWord = key || 'salesChannel';
  return {
    Component: Cascader,
    type: EnumFilterType.CustomWithoutDrop,
    keyWord,
    options,
    dropdownProps: { name: dropdownName || 'Sales Channel' },
    onCustomConfirm: function ({ value: e = {}, onChange }) {
      const value = e[keyWord];

      if (value.length === 2) {
        const [type, channel] = value;
        if (type && channel) {
          const _type = { ...type };
          const _channel = { ...channel };
          const { value: channelValue } = _channel;
          const { value: typeValue } = _type;
          // const relatedValue = [channelValue + typeValue];
          _channel.relativeValue = [typeValue];
          _type.relativeValue = [channelValue];
          _type.invisible = true;
          _type.canSkip = true;
          if (onChange) onChange({ [keyWord]: [_type, _channel] });
          return;
        }
        if (onChange) {
          onChange(e);
          return;
        }
      }
      if (onChange) onChange(e);
    },
  };
}
